import React, {useEffect} from 'react';
import {BrowserRouter as Router, Navigate, Route, Routes, useLocation} from 'react-router-dom'
import classNames from "classnames";
import {Provider} from 'react-redux';
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translations from "./translations";
import {Navbar, SimpleNavbar} from "./components/Navbar";
import Modals from "./components/Modals";
import {createAppStore} from "./store";
import reducer from './store/reducer';
import {history} from "./utils/history";
import toast, {Toaster} from 'react-hot-toast';
import BuilderPage from "./pages/Builder";
import CharacterPage from "./pages/Character";
import AirdropsPage from "./pages/Airdrops";

const initialState = {};
const store = createAppStore(reducer, initialState);

const parseLanguageCode = (code) => {
    // Extract the primary language subtag (before the hyphen if present)
    return code.split('-')[0];
};
const userLanguage = navigator.language || navigator.userLanguage;
const parsedLanguage = parseLanguageCode(userLanguage);
const defaultLanguage = 'en'; // Default language for your app
const supportedLanguages = ['en']; // Languages your app supports

i18n
    .use(initReactI18next)
    .init({
        resources: translations,
        lng: supportedLanguages.includes(parsedLanguage) ? parsedLanguage : defaultLanguage,
        fallbackLng: defaultLanguage,
        interpolation: {
            escapeValue: false
        }
    });

const withNavBar = (Component) => () => (
    <React.Fragment>
      <Navbar/>
      <Component/>
    </React.Fragment>
);

const withSimpleNavBar = (Component) => () => (
    <React.Fragment>
        <SimpleNavbar/>
        <Component/>
    </React.Fragment>
);

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
    return (
      <Provider store={store}>
          <Router historu={history}>
              <div className={classNames('App')}>
              <ScrollToTop/>
              <Routes>
                  <Route exact path="/" element={withNavBar(BuilderPage)()}/>
                  <Route exact path="/v/:id" element={withSimpleNavBar(CharacterPage)()}/>
                  <Route exact path="/claim/:slug" element={withNavBar(AirdropsPage)()}/>
                  <Route exact path="/claim" element={withNavBar(AirdropsPage)()}/>
                  {/* default redirect to home page */}
                  <Route path="*" element={<Navigate to="/" />} />
              </Routes>
              </div>
              <Toaster containerStyle={{
                  zIndex: 9999999999
              }}
                       toastOptions={{
                           success: {
                               style: {
                                   background: 'rgba(0, 0, 0, 0.2)',
                                   border: 'none',
                                   color: '#ffffff',
                                   fontWeight: 600
                               },
                               iconTheme: {
                                   primary: '#FF4E02',
                                   secondary: 'white',
                               },
                           },
                           error: {
                               style: {
                                   background: 'rgba(0, 0, 0, 0.2)',
                                   border: 'none',
                                   color: '#ffffff',
                                   fontWeight: 600
                               },
                               iconTheme: {
                                   primary: '#FF4E02',
                                   secondary: 'white',
                               },
                           },
                       }}/>
              <Modals/>
          </Router>
      </Provider>
  );
}

export default App;
